module.exports = __webpack_public_path__ + "img/sub.ad0933ab.png";